// extracted by mini-css-extract-plugin
module.exports = {"animComponent":"MainPageAnimation_animComponent__21Qvb"};